// src/components/canvasRecorder/backgrounds/canvasBackgrounds.ts

import CanvasBG1 from "./compressed/canvasBG-1.jpg";
import CanvasBG2 from "./compressed/canvasBG-2.jpg";
import Aurora from "./compressed/aurora.jpg";
import BerryTwighlight from "./compressed/berry-twighlight.jpg";
import Geometric1 from "./compressed/geometric-1.jpg";
import Geometric2 from "./compressed/geometric-2.jpg";
import Holo1 from "./compressed/holo-1.jpg";
import Holo2 from "./compressed/holo-2.jpg";
import Holo3 from "./compressed/holo-3.jpg";
import Holo4 from "./compressed/holo-4.jpg";
import Holo5 from "./compressed/holo-5.jpg";
import Holo6 from "./compressed/holo-6.jpg";
import Marble1 from "./compressed/marble-1.jpg";
import Marble2 from "./compressed/marble-2.jpg";
import MidnightJewel from "./compressed/midnight-jewel.jpg";
import SoftPastelGlow from "./compressed/soft-pastel-glow.jpg";
import ModernMinimalistOffice from "./compressed/modern-minimalist-office.jpg";
import PenNearPapersNotepad from "./compressed/pen-near-papers-notepad-smartphone.jpg";
import TopViewDeskAssortment from "./compressed/top-view-desk-assortment.jpg";
import BrownTableSurrounded from "./compressed/brown-table-surrounded.jpg";
import BlurredViewCorridor from "./compressed/blurred-view-corridor.jpg";

import ThumbCanvasBG1 from "./thumbnails/canvasBG-1.jpg";
import ThumbCanvasBG2 from "./thumbnails/canvasBG-2.jpg";
import ThumbAurora from "./thumbnails/aurora.jpg";
import ThumbBerryTwighlight from "./thumbnails/berry-twighlight.jpg";
import ThumbGeometric1 from "./thumbnails/geometric-1.jpg";
import ThumbGeometric2 from "./thumbnails/geometric-2.jpg";
import ThumbHolo1 from "./thumbnails/holo-1.jpg";
import ThumbHolo2 from "./thumbnails/holo-2.jpg";
import ThumbHolo3 from "./thumbnails/holo-3.jpg";
import ThumbHolo4 from "./thumbnails/holo-4.jpg";
import ThumbHolo5 from "./thumbnails/holo-5.jpg";
import ThumbHolo6 from "./thumbnails/holo-6.jpg";
import ThumbMarble1 from "./thumbnails/marble-1.jpg";
import ThumbMarble2 from "./thumbnails/marble-2.jpg";
import ThumbMidnightJewel from "./thumbnails/midnight-jewel.jpg";
import ThumbSoftPastelGlow from "./thumbnails/soft-pastel-glow.jpg";
import ThumbModernMinimalistOffice from "./thumbnails/modern-minimalist-office.jpg";
import ThumbPenNearPapersNotepad from "./thumbnails/pen-near-papers-notepad-smartphone.jpg";
import ThumbTopViewDeskAssortment from "./thumbnails/top-view-desk-assortment.jpg";
import ThumbBrownTableSurrounded from "./thumbnails/brown-table-surrounded.jpg";
import ThumbBlurredViewCorridor from "./thumbnails/blurred-view-corridor.jpg";

export type BackgroundType = "image" | "color" | "gradient";

export interface CanvasBackground {
  label: string;
  value: string;
  type: BackgroundType;
  src?: string;
  thumbnail?: string;
  color?: string;
}

export const canvasBackgrounds: CanvasBackground[] = [
  {
    label: "Default Gradient",
    value: "gradient-default",
    type: "gradient",
    color:
      "linear-gradient(180deg, rgba(72, 133, 237, 1) 0%, rgba(153, 102, 255, 1) 100%)",
  },
  {
    label: "Cosmic Indigo",
    value: "gradient-cosmic-indigo",
    type: "gradient",
    color: "radial-gradient(circle at 50% 50%, rgba(73,76,212,1) 0%, rgba(3,1,50,1) 100%)",

  },
  {
    label: "Lilac Ice",
    value: "gradient-lilac-ice",
    type: "gradient",
    color: "radial-gradient(circle at 10% 20%, rgba(132,94,194,1) 0%, rgba(196,243,251,1) 90%)",

  },
  {
    label: "Ultraviolet Bloom",
    value: "gradient-ultraviolet-bloom",
    type: "gradient",
    color: "radial-gradient(circle at 3.2% 49.6%, rgba(80,12,139,0.87) 0%, rgba(161,10,144,0.72) 84%)",

  },
  {
    label: "Teal Mist",
    value: "gradient-teal-mist",
    type: "gradient",
    color: "radial-gradient(circle at 0% 52%, rgba(0,56,68,1) 0%, rgba(163,217,185,1) 52%, rgba(255,252,247,1) 89%)",

  },
  {
    label: "Iridescent Veil",
    value: "gradient-iridescent-veil",
    type: "gradient",
    color:
      "linear-gradient(109.6deg, rgba(112,246,255,0.33) 11.2%, rgba(221,108,241,0.26) 42%, rgba(229,106,253,0.71) 71.5%, rgba(123,183,253,1) 100.2%)",
  },
  {
    label: "Azure Flow",
    value: "gradient-azure-flow",
    type: "gradient",
    color:
      "linear-gradient(89.5deg, rgba(131,204,255,1) 0.4%, rgba(66,144,251,1) 100.3%)",
  },
  {
    label: "Aqua Neon",
    value: "gradient-aqua-neon",
    type: "gradient",
    color:
      "radial-gradient(circle farthest-corner at 10% 20%, rgba(2,37,78,1) 0%, rgba(4,56,126,1) 19.7%, rgba(85,245,221,1) 100.2%)",
  },
  {
    label: "Plum Noir",
    value: "gradient-plum-noir",
    type: "gradient",
    color:
      "radial-gradient(circle farthest-corner at 10% 20%, rgba(100,43,115,1) 0%, rgba(4,0,4,1) 90%)",
  },
  {
    label: "Glacial Blue",
    value: "gradient-glacial-blue",
    type: "gradient",
    color:
      "radial-gradient(circle farthest-corner at 48.4% 47.5%, rgba(122,183,255,1) 0%, rgba(21,83,161,1) 90%)",
  },
  {
    label: "Coral Horizon",
    value: "gradient-coral-horizon",
    type: "gradient",
    color:
      "linear-gradient(68.3deg, rgba(245,177,97,1) 0.4%, rgba(236,54,110,1) 100.2%)",
  },
  {
    label: "Powder Day",
    value: "gradient-powder-day",
    type: "gradient",
    color:
      "linear-gradient(109.6deg, rgba(204,228,247,1) 11.2%, rgba(237,246,250,1) 100.2%)",
  },
  {
    label: "Candy Sunset",
    value: "gradient-candy-sunset",
    type: "gradient",
    color:
      "linear-gradient(102.4deg, rgba(253,189,85,1) 7.8%, rgba(249,131,255,1) 100.3%)",
  },
  {
    label: "Sunburst Amber",
    value: "gradient-sunburst-amber",
    type: "gradient",
    color:
      "linear-gradient(107.7deg, rgba(235,230,44,0.55) 8.4%, rgba(252,152,15,1) 90.3%)",
  },
  {
  label: "Purple", value: "purple", type: "color", color: "rgba(74, 60, 250)",
},
{
  label: "Pink", value: "pink", type: "color", color: "rgb(231, 79, 113)",
},
{
  label: "Blue", value: "blue", type: "color", color: "rgb(23, 213, 255)",
},
{
  label: "Indigo", value: "indigo", type: "color", color: "rgb(99, 102, 241)",
},
{
  label: "Teal", value: "teal", type: "color", color: "rgb(20, 184, 166)",
},
{
  label: "Green", value: "green", type: "color", color: "rgb(72, 187, 120)",
},
{
  label: "Yellow", value: "yellow", type: "color", color: "rgb(236, 201, 75)",
},
{
  label: "Red", value: "red", type: "color", color: "rgb(239, 68, 68)",
},
{
  label: "Black", value: "black", type: "color", color: "rgb(0, 0, 0)",
},
{
  label: "Dark Gray", value: "dark-gray", type: "color", color: "rgb(37, 45, 53)",
},
{
  label: "Gray", value: "gray", type: "color", color: "rgb(104, 114, 124)",
},
{
  label: "Light Gray", value: "light-gray", type: "color", color: "rgb(203, 213, 224)",
},
{
  label: "White", value: "white", type: "color", color: "rgb(255, 255, 255)",
},


  // Images (compressed full-size + thumbnails for preview)
  { label: "Image 1", value: "image1", type: "image", src: CanvasBG1, thumbnail: ThumbCanvasBG1 },
  { label: "Image 2", value: "image2", type: "image", src: CanvasBG2, thumbnail: ThumbCanvasBG2 },
  { label: "Aurora", value: "aurora", type: "image", src: Aurora, thumbnail: ThumbAurora },
  { label: "Berry Twighlight", value: "berry-twighlight", type: "image", src: BerryTwighlight, thumbnail: ThumbBerryTwighlight },
  { label: "Geometric 1", value: "geometric-1", type: "image", src: Geometric1, thumbnail: ThumbGeometric1 },
  { label: "Geometric 2", value: "geometric-2", type: "image", src: Geometric2, thumbnail: ThumbGeometric2 },
  { label: "Holo 1", value: "holo-1", type: "image", src: Holo1, thumbnail: ThumbHolo1 },
  { label: "Holo 2", value: "holo-2", type: "image", src: Holo2, thumbnail: ThumbHolo2 },
  { label: "Holo 3", value: "holo-3", type: "image", src: Holo3, thumbnail: ThumbHolo3 },
  { label: "Holo 4", value: "holo-4", type: "image", src: Holo4, thumbnail: ThumbHolo4 },
  { label: "Holo 5", value: "holo-5", type: "image", src: Holo5, thumbnail: ThumbHolo5 },
  { label: "Holo 6", value: "holo-6", type: "image", src: Holo6, thumbnail: ThumbHolo6 },
  { label: "Marble 1", value: "marble-1", type: "image", src: Marble1, thumbnail: ThumbMarble1 },
  { label: "Marble 2", value: "marble-2", type: "image", src: Marble2, thumbnail: ThumbMarble2 },
  { label: "Midnight Jewel", value: "midnight-jewel", type: "image", src: MidnightJewel, thumbnail: ThumbMidnightJewel },
  { label: "Soft Pastel Glow", value: "soft-pastel-glow", type: "image", src: SoftPastelGlow, thumbnail: ThumbSoftPastelGlow },
  { label: "Modern Minimalist Office", value: "modern-minimalist-office", type: "image", src: ModernMinimalistOffice, thumbnail: ThumbModernMinimalistOffice },
  { label: "Pen & Papers Desk", value: "pen-near-papers-notepad-smartphone", type: "image", src: PenNearPapersNotepad, thumbnail: ThumbPenNearPapersNotepad },
  { label: "Top-View Desk Assortment", value: "top-view-desk-assortment", type: "image", src: TopViewDeskAssortment, thumbnail: ThumbTopViewDeskAssortment },
  { label: "Brown Table Setup", value: "brown-table-surrounded", type: "image", src: BrownTableSurrounded, thumbnail: ThumbBrownTableSurrounded },
  { label: "Blurred Corridor", value: "blurred-view-corridor", type: "image", src: BlurredViewCorridor, thumbnail: ThumbBlurredViewCorridor },
];
